import React, {useState} from 'react';
import './onboard-tabs-style.scss';
import {isMobilApp} from "../../../store/AgentStore";
import line from "assets/images/login/login-option-s.svg";

const OnboardTabs = (props) => {

    const {defaultActiveTab, onChange, tabs, showLine} = props;
    const [selectTab, setSelectTab] = useState(defaultActiveTab);

    const handleChangeTab = (value) => {
        if (value !== selectTab) {
            setSelectTab(value);
            if (onChange !== undefined)
                onChange(value);
        }
    }

    const render = () => {
        return tabs?.map((tab, index) => {
            if (tab.onlyShowMobil && !isMobilApp()) return null;
            else
                return (
                    <div key={index} className="onboard-tabs-block-root" onClick={() => handleChangeTab(tab.key)}>
                        <div
                            className={"onboard-tabs-block " + (selectTab === tab.key ? 'onboard-tabs-blk-act' : '')}>
                            <img className={selectTab === tab.key ? 'onboard-tabs-block-active' : ''}
                                 alt="option" src={tab.icon}/>
                        </div>
                        <p className={"onboard-tabs-block-text " + (selectTab === tab.key ? 'onboard-tabs-block-active' : '')}>{tab.label}</p>
                        {showLine && (
                            <div className="onboard-tabs-block-line">
                                {selectTab === tab.key && (<img alt="line" src={line}/>)}
                            </div>
                        )}
                    </div>
                );
        })
    }

    return (
        <div className="onboard-tabs-root">
            <div className="onboard-tabs-root-blk">
                {render()}
            </div>
            <div className="h-8"></div>
            <div className="onboard-tabs-line"></div>
        </div>
    )
};

export default OnboardTabs;
